import React from "react";
import Skeleton from "react-loading-skeleton";
import { formatCurrency } from "utils/HelperFunctions";
import { formatPaymentListDate } from "utils/DateFormat";
import { PlanData, PlanProduct } from "types/subscriptionAndPlans";

interface PlanDisplayProps {
  isLoading: boolean;
  productList: PlanProduct[];
  currentPlan?: PlanData | Record<string, any>;
  frequency: string;
  financialSettings: any;
  companyDetails: any;
  userData: any;
}

const PlanDisplay: React.FC<PlanDisplayProps> = ({
  isLoading,
  productList,
  currentPlan,
  frequency,
  financialSettings,
  userData,
}) => (
  <div className="w-full py-5 lg:px-0 px-5">
    <div className="text-txtPrimary lg:text-sm text-xs lg:leading-[18.23px] leading-[15.62px] uppercase">
      Current plan
    </div>
    <div className="w-full h-[1px] bg-strokePrimary my-5"></div>
    <div className="flex w-full flex-col gap-4">
      {isLoading
        ? [1, 2].map((item, index) => (
            <React.Fragment key={index}>
              <Skeleton width={100} height={25} />
              <Skeleton width={260} height={22} />
            </React.Fragment>
          ))
        : productList?.length > 0 &&
          productList?.map((item, index) => (
            <React.Fragment key={index}>
              <div className="w-full flex gap-2 items-center text-txtParagraph lg:text-[22px] text-xl font-medium leading-[28.64px]">
                {item?.productDetails?.name}
                {item?.quantity > 1 ? ` x${item?.quantity}` : ""}
              </div>
              <div className="lg:text-xl text-lg lg:leading-[26.04px] leading-[23.44px] text-txtPrimary font-bold">
                {formatCurrency(item?.amount * (item?.quantity || 1)) ||
                  "$0.00"}{" "}
                {frequency}
              </div>
            </React.Fragment>
          ))}
      {financialSettings?.cancel_settings === "EOP" ? (
        <>
          <div className="lg:text-base text-sm lg:leading-[20.83px] leading-[18.23px] text-txtPrimary w-full break-words">
            If you change your mind, you can renew your subscription.
          </div>
          <div className="lg:text-base text-sm lg:leading-[20.83px] leading-[18.23px] text-txtPrimary w-full break-words">
            Your plan will be canceled, but is still available until the end of
            your billing period on{" "}
            {isLoading ? (
              <Skeleton width={150} height={15} />
            ) : (
              `${formatPaymentListDate(
                currentPlan?.next_billing_date,
                userData?.data?.accountData?.timezone,
                "short",
              )}.`
            )}
          </div>
        </>
      ) : (
        <div className="lg:text-base text-sm lg:leading-[20.83px] leading-[18.23px] text-txtPrimary w-full break-words">
          If you cancel this plan, it will no longer be available to you.
        </div>
      )}
    </div>
    {/* <div className="pt-[60px] w-full flex flex-col gap-5">
      <div className="text-txtParagraph lg:text-sm text-xs">
        By confirming your new plan, you agree to{" "}
        {companyDetails?.name || companyDetails?.company_name} LLC’s{" "}
        <a
          target="_blank"
          href={"https://www.dcdial.com/legal/terms-of-service"}
          className="text-txtPrimary font-semibold hover:!text-blue hover:!underline"
        >
          Terms of Service
        </a>{" "}
        and{" "}
        <a
          target="_blank"
          href={"https://www.dcdial.com/legal/privacy-policy"}
          className="text-txtPrimary font-semibold hover:!text-blue hover:!underline"
        >
          Privacy Policy
        </a>
        .
      </div>
    </div> */}
  </div>
);

export default PlanDisplay;
